import { uniqueId } from 'lodash';
import { url } from 'configs/';
import companyRuleIcon from '../../images/links/tube/icon_company_policies.svg';
import deptAnnounceIcon from '../../images/links/tube/icon_department_announcement.svg';
import assignmentIcon from '../../images/links/tube/icon_assignment.svg';
import internalLinksIcon from '../../images/links/tube/icon_internal_link.svg';
import newsIcon from '../../images/links/tube/icon_news.svg';
import notesIcon from '../../images/links/tube/icon_notes.svg';
import orderIcon from '../../images/links/tube/icon_order.svg';
import stayfunIcon from '../../images/links/tube/icon_stayfun.svg';

const module = 'NewTube';
const baseUrl = url.NEWTUBE_API_SERVER;

export default [
  {
    id: uniqueId(),
    module,
    i18nKey: 'FD_CompanyPolicies',
    icon: companyRuleIcon,
    url: '/tube/companyrules',
    messageApi: null,
    sort: 7,
    onlySupervisor: false,
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'FD_DeptAnnouncement',
    icon: deptAnnounceIcon,
    url: '/tube/departmentnews',
    messageApi: `${baseUrl}/announcement/department`,
    sort: 8,
    onlySupervisor: false,
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'FD_NewsMsg',
    icon: newsIcon,
    url: '/tube/companynews',
    messageApi: `${baseUrl}/announcement/company`,
    sort: 9,
    onlySupervisor: false,
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'FD_NewOrder',
    icon: orderIcon,
    url: '/tube/orders/active',
    messageApi: `${baseUrl}/orders/unfinished`,
    sort: 10,
    onlySupervisor: false,
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'FD_Todo',
    icon: assignmentIcon,
    url: '/tube/assignmenttask/',
    messageApi: `${baseUrl}/assignment/tome`,
    sort: 13,
    onlySupervisor: false,
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'FD_Sticker',
    icon: notesIcon,
    url: '/tube/stickynotes/',
    messageApi: `${baseUrl}/postnote/received/unread`,
    sort: 14,
    onlySupervisor: false,
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'FD_InternalLink',
    icon: internalLinksIcon,
    url: '/tube/internallinks',
    messageApi: null,
    sort: 16,
    onlySupervisor: false,
  },
  {
    id: uniqueId(),
    module: 'Stayfun',
    i18nKey: 'STAYFUN',
    icon: stayfunIcon,
    url: url.STAYFUN || 'https://stayfun.mayohr.com/Account/Signin?UrlParameter=https%3A%2F%2Fstayfun.mayohr.com%2F',
    messageApi: null,
    sort: 18,
    onlySupervisor: false,
  },
];



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/Index/config/links/tube.js
 **/